import {MeetingRole} from "../const";
import {ModelInterface} from "../../../data-structures/collection";

const debug = false
// const debug = "MeetingUser"


export default class MeetingUser implements ModelInterface {

    public userId               : ID
    public role             : MeetingRole

    constructor(data:any) {

        this.userId           = data.userId
        this.role               = data.role
    }

    get id() {
        return this.userId
    }

    toJSON() {
        return {}
    }


}



